import { Button, Icon } from '@innovationnorway/cl-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onSubmit: () => void;
  onClose?: () => void;
};

const FeedBackSent: React.FC<Props> = ({ onSubmit, onClose }) => {
  const { t: tCommon } = useTranslation('common');
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  return (
    <>
      <span className="font-size--large font-weight--bold">{tOneWayIn('opportunity.feedback.thankYou')}</span>
      <p>{tOneWayIn('opportunity.feedback.forwardToAnotherActor')}</p>
      <div className="display--flex gap--2 align-self--flex-end">
        <Button onClick={onSubmit} variant="primary">
          <Icon prefix="fasr" iconName="paper-plane" />
          {tOneWayIn('opportunity.feedback.goToReferral')}
        </Button>
        <Button onClick={onClose} variant="secondary">
          {tCommon('close')}
        </Button>
      </div>
    </>
  );
};

export default FeedBackSent;
